import React from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { ProgressStepsItems } from 'constants/progress-steps-constants';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from "__utils/type";
import { Row, Col } from 'antd';

const ProgressStepsContainer = styled.nav<CommonStyledComponentProps>`
    margin-bottom: 24px;
    .steps {
      color: ${COLOR.BLACK};
      display: flex;
      list-style: none;
      padding: 0 ;
      justify-content: ${(props: any) => props.isMobile ? 'center' : "flex-start"};
      text-align: center;
      width: 100%;
    }
    .steps li {
      background: ${COLOR.WHITE};
      border-bottom: 2px solid #d2d5d6 ;
      width: 20%;
    }
    .steps li:last-child {
      margin-right: 0px !important;
    }
    #step {
      color: grey;
    } 
    .active {
      border-bottom: 2px solid #00a465 !important;
      }
    .dispText {
      font-weight:500;
    }
`;

interface StepProps {
  stepsList?: Array<ProgressStepsItems> | any,
  currentStep: number,
  stepTag?: React.ReactElement
}

const OnboardingProgressSteps: React.FC<StepProps> = (props: StepProps) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const stepItems = []
  for (const [index, value] of props.stepsList.entries()) {
    stepItems.push(
      <li key={index} style={{ marginRight: "5px", marginTop: "10px" }} className={(index <= props.currentStep) ? "active" : ""}>
      </li >

    )
  }

  return (
    <ProgressStepsContainer isMobile={isMobile}>
      <Row>
        <Col xs={24} md={12}>
          <nav className="container">
            {
              <div>
                <div style={{display:'flex',justifyContent:'space-between'}}>
                  <Link to={props.stepsList[props.currentStep].route} >
                    <span id="step"> Step {props.currentStep + 1}/5 </span> : <span className="dispText">{props.stepsList[props.currentStep].displayText}</span>
                  </Link>
                  {props?.stepTag}
                </div>

                <ul className="steps">
                  {stepItems}
                </ul>
              </div>
            }
          </nav>
        </Col>
      </Row>
    </ProgressStepsContainer>
  );
};

export default OnboardingProgressSteps;
